module.exports = __webpack_public_path__ + "static/media/23 Mount.dc970c2e.jpg";